const featureItems = [
  {
    id: 1,
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '完美适配手机和电脑的下拉式阅读体验，无需翻页，一气呵成看个过瘾。',
  },
  {
    id: 2,
    icon: 'ri-timer-flash-line',
    title: '实时追更',
    desc: '热门韩漫每日同步更新，新章节上线第一时间推送，追更快人一步，绝不掉队。',
  },
  {
    id: 3,
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '收录超过12,000部韩国漫画，涵盖恋爱、奇幻、动作等全品类，韩国漫画网站大全。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告、无恶意跳转，纯净阅读环境，让你专注享受韩漫的乐趣。',
  },
  {
    id: 5,
    icon: 'ri-group-line',
    title: '读者社区',
    desc: '活跃的韩漫爱好者交流社区，分享观感、推荐佳作、讨论剧情，找到同好。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            为什么选择韩国漫画网？五大优势让你畅享韩漫世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all duration-200 text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}